import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClientProductService {

    async getClientProducts(clientId) {
        return await axios.get(`/api/clientproduct/${clientId}`, {headers: authHeader()})
    }

    async getClientsForProduct(productId) {
        return await axios.get(`/api/clientproduct/product/${productId}`, {headers: authHeader()})
    }

    async createProductForClient(clientId, productId) {
        return await axios.post(`/api/clientproduct/${clientId}/${productId}`, null, {headers: authHeader()});
    }

    async updateSpecificProductForClient(id, data) {
        return await axios.put(`/api/clientproduct/${id}`, data, {headers: authHeader()});
    }

    async deleteSpecificProductForClient(id) {
        return await axios.delete(`/api/clientproduct/${id}`, {headers: authHeader()})
    }

}

export default new ClientProductService();
